import { TDecrementCount, TSetCounts } from '../../actions/counts';

export const COUNTS_DECREMENT: TDecrementCount = 'counts/decrement';
export const COUNTS_SET_COUNTS: TSetCounts = 'counts/set_user_favorites_count';
